function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "12",
  height: "20",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6 10a5 5 0 10-5-5 5.006 5.006 0 005 5zm0-7.5a2.5 2.5 0 110 5 2.5 2.5 0 010-5zM11.093 13.992A1.88 1.88 0 0012 12.403a1.366 1.366 0 00-.814-1.252 1.593 1.593 0 00-1.6.143c-2.137 1.473-5.035 1.473-7.172 0a1.601 1.601 0 00-1.6-.143c-.504.234-.82.72-.814 1.252.001.64.342 1.236.907 1.588a9.476 9.476 0 002.343 1.06c.141.04.287.079.436.114L1.27 17.401a1.455 1.455 0 00-.034 2.139 1.666 1.666 0 002.301-.005L6 17.124 8.47 19.54c.615.6 1.628.615 2.262.034a1.455 1.455 0 00-.003-2.177l-2.414-2.233c.15-.036.296-.074.438-.115a9.441 9.441 0 002.341-1.057z"
}))));